@if (form) {
    <div [formGroup]="form" fxLayout="column" fxLayoutAlign="start start" class="w-476">
        @if (labelTranslationKey) {
            <div class="t5 c-primary-gray-600">{{ labelTranslationKey | translate }}
                {{ form.controls.date?.hasValidator(Validators.required) ? '*' : '' }}
            </div>
        }
        <mat-form-field class="w-100 mt-4"
                        [class.value-not-empty]="form.controls.date?.value">
            <ui-kit-calendar #datepicker
                             [headerConfig]="headerConfig"
                             [showPickerActions]="showPickerActions">
                <div DatePickerActions fxLayout="column" fxLayoutAlign="start center" class="w-100">
                    @if (form.controls.time) {
                        <div fxLayout="row" fxLayoutAlign="space-between center" class="w-100">
                            <div class="t2 c-primary-gray-900">{{ 'i18n_af_labelTime' | translate }}:</div>
                            <mat-form-field class="time-input-max-width">
                                <input matInput
                                       formControlName="time"
                                       [showMaskTyped]="true"
                                       [dropSpecialCharacters]="false"
                                       [leadZeroDateTime]="true"
                                       mask="Hh:m0">
                            </mat-form-field>
                        </div>
                    }
                    @if (form.controls.time?.invalid) {
                        <mat-error
                            class="c-secondary-red-900 t5 mt-4" fxFlexAlign="end">
                            {{
                                ((form.controls.time?.hasError('required') && 'i18n_af_fieldValidationRequired')
                                    || form.controls.time?.hasError('timeInFuture') && 'i18n_af_fieldValidationDateInFuture') || '' | translate
                            }}
                        </mat-error>
                    }
                    <ui-kit-button [type]="'text'"
                                   [label]="'i18n_af_buttonOk' | translate"
                                   class="mt-16"
                                   [disabled]="form.controls.time?.hasError('required') || form.controls.date?.hasError('required')"
                                   fxFlex
                                   (clickListener)="selectDate()">
                    </ui-kit-button>
                </div>
            </ui-kit-calendar>
            <input matInput
                   [matDatepicker]="datepicker?.datePicker"
                   formControlName="date"
                   [min]="minDate"
                   [max]="maxDate"
                   [placeholder]="placeholderTranslationKey | translate"
                   (input)="dateInputChanged($event)">
            @if (iconPosition === 'right') {
                <ui-kit-svg matSuffix matRipple class="i-16 circle pointer p-8 mr-8 c-primary-gray-600" name="ic_calendar"
                            (click)="openPicker()">
                </ui-kit-svg>
            }
            @if (iconPosition === 'left') {
                <ui-kit-svg matPrefix matRipple class="i-16 circle pointer p-8 ml-8 c-primary-gray-600" name="ic_calendar"
                            (click)="openPicker()">
                </ui-kit-svg>
            }
            @if (form.controls.date?.invalid || form.controls.time?.invalid) {
                <mat-error
                    class="c-secondary-red-900">
                    {{
                        (((form.controls.date?.hasError('required') || form.controls.time?.hasError('required')) && 'i18n_af_fieldValidationRequired')
                            || ((form.controls.date?.hasError('dateInFuture') || form.controls.date?.hasError('matDatepickerMax')) && 'i18n_af_fieldValidationDateInFuture')
                            || (form.controls.date?.hasError('matDatepickerMin') && 'i18n_af_fieldValidationDateTooEarly') || '') | translate
                    }}
                </mat-error>
            }
        </mat-form-field>
    </div>
}
